import { formatCurrency, formatDate, NgClass } from "@angular/common";
import { Component, EventEmitter, inject, Input, LOCALE_ID, OnChanges, Output, SimpleChanges } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { ClassDirective } from "@ngbracket/ngx-layout/extended";
import { FlexDirective, LayoutAlignDirective, LayoutDirective, FlexFillDirective } from "@ngbracket/ngx-layout/flex";
import { LabeledFieldComponent } from "@tylertech/common-components-module";
import { ClassMetadata, IInfoCardDataElement, InfoCardActionType } from "@tylertech/tyler-api-types";

@Component({
    selector: "info-card-detail-field",
    templateUrl: "./infoCardDetailField.tmpl.html",
    styleUrls: [
        "./infoCardDetailField.component.scss"
    ],
    imports: [
        ClassDirective,
        FlexDirective,
        LayoutAlignDirective,
        LayoutDirective,
        FlexFillDirective,
        LabeledFieldComponent,
        MatIcon,
        NgClass,
    ]
})
export class InfoCardDetailFieldComponent implements OnChanges
{
    private readonly locale = inject(LOCALE_ID);


    @Input() private readonly itemMetadata: ClassMetadata;
    @Input() readonly maxWidth: number;
    @Input() readonly rows: ReadonlyArray<IInfoCardDataElement>;

    @Output() private readonly executeCommand = new EventEmitter<IInfoCardDataElement>();

    ngOnChanges(changes: SimpleChanges): void
    {
        if (changes.maxWidth && changes.maxWidth.previousValue !== changes.maxWidth.currentValue)
        {
            console.debug(`InfoCardDetailFieldComponent.maxWidth changed`, changes.maxWidth);
        }
    }

    getClass(item: IInfoCardDataElement): string
    {
        const className = item.Name.replace(/ /g, "-");
        return className;
    }

    getValue(field: IInfoCardDataElement): string
    {
        if (field.Value === undefined || field.Value === null)
        {
            return "";
        }

        if (typeof field.Value === "object"
            && field.Value.Value)
        {
            return field.Value.Value;
        }

        if (typeof field.Value === "string" && field.Value === "")
        {
            return "";
        }

        if (this.itemMetadata)
        {
            const prop = this.itemMetadata.Properties.find(p => p.Name === field.Name);
            if (!prop)
            {
                return field.Value.toString();
            }

            if (prop.InputType === "Date")
            {
                return field.Value === "-"
                    ? field.Value
                    : formatDate(field.Value, "M/d/yyyy", this.locale);
            }

            if (prop.InputType === "Currency")
            {
                // TODO - We will have to change this currencyCode if we have do deal with any foreign currency ever.
                return formatCurrency(field.Value.replace(/[$,]/g, ""), this.locale, "$");
            }
        }
        return field.Value.toString();
    }

    isAction(item: IInfoCardDataElement): boolean
    {
        return !!item.ActionType || item.InfoCardAction?.ActionType === InfoCardActionType.LinkLabel;
    }

    getActionAriaLabel(field: IInfoCardDataElement): string
    {
        return `Redirect-${field.Label}`;
    }

    isBoolean(field: IInfoCardDataElement): boolean
    {
        return /true|false/.test(this.getValue(field).toLowerCase());
    }

    isTrue(field: IInfoCardDataElement): boolean
    {
        return /true/.test(this.getValue(field).toLowerCase());
    }

    performFieldCommand($event: MouseEvent, field: IInfoCardDataElement): void
    {
        $event.stopPropagation();

        // this.$infoCardActionService.PerformFieldCommand(field, this.item, this.performCommand);
        this.executeCommand.emit(field);
    }
}
